import { RequestBillingAddressChangeType } from 'b2b-apps/shop/myAccount/accountDetails/api/BillingAddress.types';
import {
  CLEAR_BILLING_ADDRESS,
  UPDATE_BILLING_ADDRESS,
  UPDATE_BILLING_ADDRESS_FULFILLED,
  UPDATE_BILLING_ADDRESS_REJECTED,
} from './actionTypes';
import {
  ClearBillingAddressAction,
  UpdateBillingAddressAction,
  UpdateBillingAddressFulfilledAction,
  UpdateBillingAddressRejectedAction,
} from './types';

const updateBillingAddress = (billingAddress: RequestBillingAddressChangeType): UpdateBillingAddressAction => ({
  type: UPDATE_BILLING_ADDRESS,
  payload: {
    billingAddress,
  },
});

const updateBillingAddressFulfilled = (): UpdateBillingAddressFulfilledAction => ({
  type: UPDATE_BILLING_ADDRESS_FULFILLED,
});

const updateBillingAddressRejected = (error: ErrorType): UpdateBillingAddressRejectedAction => ({
  type: UPDATE_BILLING_ADDRESS_REJECTED,
  payload: {
    error,
  },
});

const clearAccountBillingAddress = (): ClearBillingAddressAction => ({
  type: CLEAR_BILLING_ADDRESS,
});

export {
  clearAccountBillingAddress,
  updateBillingAddress,
  updateBillingAddressFulfilled,
  updateBillingAddressRejected,
};
